const features = [
  {
    icon: 'ri-chat-smile-3-fill',
    title: '畅快讨论',
    desc: '围绕剧情走向、角色塑造与细节伏笔，和同好深度交流，畅所欲言。',
    tone: 'bg-primary-100 text-primary-700',
  },
  {
    icon: 'ri-team-fill',
    title: '寻找同好',
    desc: '按兴趣加入不同板块，找到愿意陪你一起追更、一起吐槽的朋友。',
    tone: 'bg-accent-100 text-accent-700',
  },
  {
    icon: 'ri-flashlight-fill',
    title: '新番速递',
    desc: '新番前瞻、开播资讯与首波口碑，剧荒时不再盲目扫雷。',
    tone: 'bg-secondary-100 text-secondary-700',
  },
  {
    icon: 'ri-book-open-fill',
    title: '深度专题',
    desc: '从热血番演进到治愈系洞察，用更有深度的内容连接彼此。',
    tone: 'bg-background-200 text-foreground-700',
  },
];

export default function Features() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {features.map((f) => (
          <div
            key={f.title}
            className="flex flex-col rounded-2xl border border-background-200 bg-background-50 p-5 text-center hover:border-primary-300 transition-colors"
          >
            <span className={`mx-auto flex h-12 w-12 items-center justify-center rounded-2xl ${f.tone}`}>
              <i className={`${f.icon} text-2xl`}></i>
            </span>
            <h3 className="mt-4 text-base md:text-lg font-bold text-foreground-950">{f.title}</h3>
            <p className="mt-2 text-xs md:text-sm leading-relaxed text-foreground-600">{f.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}